import { FormikHelpers } from "formik";
import { toast } from "react-toastify";
import { api } from "../../../../../../../Api/Api";
import { AddServicesInitialValues } from "./FormikValidation";
import axios from "axios";
import { BaseUrl } from "../../../../../../../Api/BaseUrl";

type AddInitialValues = {
  image: string;
  title: string;
};

export const ServicesSubmitHandler = async (
  values: AddInitialValues,
  actions: FormikHelpers<AddInitialValues>,
  setIsOpen: Function,
  refetch: Function,
  editMode: boolean,
  id: string | number,
  image: string
) => {
  // Edit

  if (editMode) {
    try {
      const formData = new FormData();
      if (image) {
        formData.append("icon", values.image);
      }
      formData.append("title", values?.title);
      const res = await axios.patch(
        `${BaseUrl}/service/${id}`,
        formData,

        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage.getItem("AUTH_TOKEN")}`,
          },
        }
      );
      if (res) {
        toast.success("Services Updated",{toastId:"Servicesupdate"});
        setIsOpen(false);
        refetch();
      }
    } catch (error: any) {
      actions?.setSubmitting(false);
      actions.setFieldError("image", error?.response?.data?.errors?.image);
      actions.setFieldError("icon", error?.response?.data?.errors?.icon);
    }
  } else {
    // add
    try {
      const formData = new FormData();
      if (image) {
        formData.append("icon", values.image);
      }
      formData.append("title", values?.title);
      const res = await axios.post(`${BaseUrl}/service`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("AUTH_TOKEN")}`,
        },
      });
      if (res) {
        toast.success("Services added",{toastId:"statusadd"});
        setIsOpen(false);
        refetch();
      }
    } catch (error: any) {
      actions?.setSubmitting(false);
      actions.setFieldError("image", error?.response?.data?.errors?.image);
      actions.setFieldError("title", error?.response?.data?.errors?.title);
      actions.setFieldError(
        "description",
        error?.response?.data?.errors?.description
      );
      actions.setFieldError("color", error?.response?.data?.errors?.color);
    }
  }
};

// extract Departmentdata for table
export const extractStaffData = (data: any) => {
  const res = data?.data?.map((item: any) => {
    return {
      id: item?.id,
      description: item?.description,
      image: item?.image_url,
      title: item?.title,
      colour: item?.color,
    };
  });
  return res;
};

// initializing add Department form - Edit / add
export const addModalInitialValuesHandler = (
  modalEditData: any,
  setAddModalInitialValues: Function,
  setEditMode: Function
) => {
  if (modalEditData?.length !== 0) {
    setEditMode(true);
    setAddModalInitialValues({
      id: modalEditData?.[0]?.id,
      image: modalEditData?.[0]?.icon,
      title: modalEditData?.[0]?.title,
      image_url: modalEditData?.[0]?.icon,
    });
  } else {
    setEditMode(false);
    setAddModalInitialValues(AddServicesInitialValues);
  }
};

// Department table edit onclick trigger
export const onEditClickHandler = (
  selectedId: any,
  setModalEditData: Function,
  setIsOpen: Function,
  servicesData: any
) => {
  setModalEditData([]);
  setModalEditData(
    servicesData?.data?.filter((itm: any) => itm?.id === selectedId)
  );

  setIsOpen(true);
};

// add Department open / close
export const modalHandler = (
  setModalEditData: Function,
  setIsOpen: Function
) => {
  setModalEditData([]);
  setIsOpen(true);
};

// Department delete
export const deleteClickHandler = (
  selectedId: string | number,
  refetch: Function
) => {
  api
    .delete(`/service/${selectedId}`, {}, true)
    .then(async function ([success, response]: any) {
      refetch();
      toast.success("Deleted",{toastId:"statusdelete"});
    })
    .catch((err) => {
      toast.error("Unexpected Error Occurred",{toastId:"statusdeleterr"});
    });
};

export const StatusClickHandler = (
  selectedId: string | number,
  refetch: Function,
  newStatus: number
) => {
  api
    .put(`/service/publish${selectedId}`, { status: newStatus }, true)
    .then(async function ([success, response]: any) {
      refetch();
      toast.success("Updated",{toastId:"statusupdate"});
    })
    .catch((err) => {
      toast.error("Unexpected Error Occurred",{toastId:"statusupdaterr"});
    });
};
export const setCurrentPageaward = (navigate: Function, pageNo: any) => {
  navigate(`/admin/staff/${pageNo}`);
};
